var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2285 11.2969C15.2285 12.0925 14.9124 12.8556 14.3498 13.4182C13.7872 13.9808 13.0242 14.2969 12.2285 14.2969C11.4329 14.2969 10.6698 13.9808 10.1072 13.4182C9.54459 12.8556 9.22852 12.0925 9.22852 11.2969C9.22852 10.5012 9.54459 9.73816 10.1072 9.17555C10.6698 8.61295 11.4329 8.29688 12.2285 8.29688C13.0242 8.29688 13.7872 8.61295 14.3498 9.17555C14.9124 9.73816 15.2285 10.5012 15.2285 11.2969Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7285 11.2969C19.7285 18.4389 12.2285 22.5469 12.2285 22.5469C12.2285 22.5469 4.72852 18.4389 4.72852 11.2969C4.72852 9.30775 5.51869 7.4001 6.92521 5.99357C8.33174 4.58705 10.2394 3.79688 12.2285 3.79688C14.2176 3.79688 16.1253 4.58705 17.5318 5.99357C18.9383 7.4001 19.7285 9.30775 19.7285 11.2969Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.6ac4743856700ef21308666b43cf4bf4.svg";
export { ForwardRef as ReactComponent };